<template>
  <v-form ref="form" lazy-validation>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-text-field
              :loading="loading"
              dense
              v-model="address.addressee"
              label="Destinatario"
              :rules="[v => !!v || 'Destinatario obbligatorio']"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              v-model="address.city"
              dense disabled
              label="Comune"
              :rules="[v => !!v || 'Comune obbligatorio']"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              :loading="loading"
              dense
              v-model="address.street_name"
              label="Nome strada, piazza viale"
              :rules="[v => !!v || 'Nome obbligatorio']"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              :loading="loading"
              dense
              v-model="address.street_number"
              label="Numero civico"
              :rules="[v => !!v || 'civico obbligatorio']"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              :loading="loading"
              dense
              v-model="address.postcode"
              label="Cap"
              :rules="[v => !!v || 'Cap obbligatorio',rules.isValidCap]"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              :loading="loading"
              dense
              v-model="address.phone"
              label="Telefono"
              :rules="[v => !!v || 'Telefono obbligatorio',rules.isValidNumber]"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              :loading="loading"
              v-model="address.apartment"
              dense
              label="Scala, piano, interno ecc. (Opzionale)"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
              :loading="loading"
              dense
              v-model="address.notes"
              label="Abbiamo bisogno di istruzioni aggiuntive per trovare questo indirizzo?"
              placeholder="Fornisci dettagli come la descrizione dell'edificio, un punto di riferimento nelle vicinanze o altre istruzioni di navigazione."
          ></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-checkbox
              :loading="loading"
              v-model="address.default"
              label="Indirizzo di default"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import StoreComputed from "@/mixins/StoreComputed";

export default {
  name: "ShippingAddressForm",
  mixins: [StoreComputed],

  props: ["addressData", "loading"],
  data: () => ({
    address: {
      addressee: "",
      city: "Roma",
      country: "IT",
      region: "Lazio",
      district: "RM",
      postcode: "",
      street_name: "",
      street_number: "",
      phone: "",
      shipping: true,
      billing: false,
      default: false,
      apartment: "",
      notes: "",
    },
    rules: {
      isValidCap: (value) => {
        let regex = RegExp(/^[0-9]{5}$/);
        return regex.test(value) || 'Inserire un cap valido'
      },
      isValidNumber: (value) => {
        let regex = RegExp(/^[0-9]{9,11}$/);
        return regex.test(value) || 'Inserire un numero di telefono valido'
      },
    },
  }),
  mounted() {
    if (this.addressData !== undefined && this.addressData !== null) {
      let address = Object.assign({}, this.addressData);
      delete address.id;
      delete address.created_at;
      delete address.updated_at;
      delete address.deleted_at;

      this.address = address;
    }
  }
}
</script>

<style scoped>
</style>